const Auxi = props => props.children


export default Auxi


// WEBPACK FOOTER //
// ./src/hoc/Auxi/Auxi.js